'use client';

import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { Colors } from './types';
import { cn } from './lib/utils';
import { useFlatUI } from './flat-ui';

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> & {
    color?: 'default' | Colors;
  }
>(({ className, sideOffset = 4, color = 'default', ...props }, ref) => {
  const flat = useFlatUI();

  return (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        'z-[10000] overflow-hidden rounded-md px-3 py-1.5 text-xs animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        {
          'bg-neutral-900 text-white': color === 'default',
          'bg-primary text-primary-foreground': color === 'primary',
          'bg-secondary text-secondary-foreground': color === 'secondary',
          'bg-success text-success-foreground': color === 'success',
          'bg-error text-error-foreground': color === 'error',
          'bg-info text-info-foreground': color === 'info',
          'bg-warning text-warning-foreground': color === 'warning',
        },
        className,
        flat && 'shadow-none border-border'
      )}
      {...props}
    />
  </TooltipPrimitive.Portal>
  );
});
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
